import Image from './Image';

// export types
export type { ImageProps } from './Image';

// export components
export { Image };
export default Image;
